<template>
  <div class="content">
    <div class="banner"></div>
    <!-- 产品列表 -->
    <list-com :logInfo="logInfo" />
  </div>
</template>

<script>
import listCom from "./component/orderlist";
import { initList } from "../../util/initList.js";
export default {
  name: "ProductList",
  components: {
    listCom
  },
  data() {
    return {
      logInfo: initList
    };
  },
  created() {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
/* 主体内容 */
.content {
  width: 100%;
  background-color: #f6f6f6;
  .banner {
    width: 100%;
    height: 380px;
    background: #fff url(../../assets/banner.png) center no-repeat;
    background-size: 100% 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/qianfan/productList.vue